// Leestijd per module, afgeleid van de werkelijke inhoud (geen vaste getallen).
import ai from './content/ai';
import dg from './content/dg';
import mw from './content/mw';
import dv from './content/dv';
import sm from './content/sm';
import { ThemeContent } from './content/types';
import { ThemeId } from './learning';

const CONTENT: Record<ThemeId, ThemeContent> = { ai, dg, mw, dv, sm };

const wordCount = (s: string) => s.split(/\s+/).filter(Boolean).length;

// Geschatte leestijd in minuten (≈ 150 woorden/min, incl. de kernpunten).
export function moduleMinutes(themeId: ThemeId, moduleIdx: number): number {
  const parts = CONTENT[themeId]?.[moduleIdx] || [];
  let words = 0;
  for (const p of parts) {
    words += wordCount((p.paragraphs || []).join(' '));
    words += wordCount((p.keyPoints || []).join(' '));
  }
  return Math.max(2, Math.round(words / 150));
}

// Totale leestijd van een heel thema (alle modules).
export function themeMinutes(themeId: ThemeId): number {
  const c = CONTENT[themeId] || {};
  return Object.keys(c).reduce((sum, k) => sum + moduleMinutes(themeId, Number(k)), 0);
}
